import { QuestionnaireStatusInfo } from "@/Common/Models/Questionnaires/QuestionnaireStatusInfo";

class PatientAppointmentItem {
    public Subject: string;
    public SiteName: string;
    public With: string;
    public Room: string;
    public StartTimeHour: string;
    public EndTimeHour: string;
    public StartDate: Date;
    public StartTimeFullDate: string;
    public StartTimeDateList: string;
    public EndTimeFullDate: string;
    public StateId: string;
    public StateName: string;
    public StateCode: string;
    public Notes: string;
    public IsPaid: boolean;
    public SiteId: string;
    public AppointmentId: string;
    public IsFuturAppointment: boolean;
    public AppointmentComboId: string;
    public ComboPrimaryAppointmentId: string;
    public ComboId: number;
    public ComboName: string;
    public ServiceDefinitionId: string;
    public ServiceDefinitionName: string;
    public IsSharedWithPortal: boolean;
    public IsPatientNotificationsEnabled: boolean;
    public IsTeleconsultation: boolean;
    public QuestionnaireStatusInfo: QuestionnaireStatusInfo;
    public CanadianTriageAndAcuityScore: number;
    public EmployeeAndRoomId: string;

    // ------------- Appointment Event Feeds from Third-party Systems. (Myle is mirroring an Third-party system calendar)
    /// <summary>Third-party system Appointment Id.</summary>
    public IsReadOnly: boolean;

    constructor(fields?: Partial<PatientAppointmentItem>) {
        Object.assign(this, fields);
    }
}

export { PatientAppointmentItem };
